import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { HStack, IconCTAButton } from "./utils";

type EmployeePortalPreviewProps = {
  open: boolean;
  accessToken: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  onClose: () => void;
};

export function EmployeePortalPreview({
  open,
  accessToken,
  iframeRef,
  onClose,
}: EmployeePortalPreviewProps) {
  const titleId = React.useId();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const iframeUrl = accessToken
    ? `${process.env.REACT_APP_EMP_PORTAL}/login?token=${encodeURIComponent(
        accessToken
      )}&adminEmployeeView=true`
    : undefined;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="xl"
      PaperProps={{
        sx: {
          width: fullScreen ? "100%" : "calc(100% - 32px)",
          height: fullScreen ? "100%" : "calc(100vh - 32px)",
          maxHeight: fullScreen ? "100%" : "calc(100vh - 32px)",
          m: fullScreen ? 0 : 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle component="div" sx={{ p: { xs: 2, sm: 3 } }}>
        <HStack className="w-full items-center justify-between gap-4">
          <h2
            id={titleId}
            className="text-base font-semibold leading-6 text-headerColor"
          >
            Employee portal preview
          </h2>
          <IconCTAButton
            iconOnly
            iconName="lucide:x"
            aria-label="Close employee portal preview"
            title="Close preview"
            onClick={onClose}
            className="shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          />
        </HStack>
      </DialogTitle>
      <DialogContent
        className="relative min-h-0 flex-1 border-t border-borderColor"
        sx={{ p: 0, overflow: "hidden" }}
      >
        <iframe
          ref={iframeRef}
          title="Employee portal preview"
          className="absolute inset-0 block h-full w-full border-0"
          src={iframeUrl}
        />
      </DialogContent>
    </Dialog>
  );
}
